<template>
  <sg-link
    class="social-login-btn social-btn"
    :to="buildUrl('/auth/' + provider).toString()">
    <img
      :src="`/images/icons/${provider}.svg`"
      :alt="`${provider}`"
      class="social-icon" />
    <slot></slot>
  </sg-link>
</template>

<script>
  import SgLink from 'sb/common/components/SgLink.vue'

  export default {

    props: {
      provider: {
        type: String,
        required: true
      },
    },

    components: {
      SgLink,
    },

    methods: {
      buildUrl(path) {
        let url = new URL(path, location.origin)
        url.search = new URLSearchParams(location.search)
        return url
      }
    }

  }
</script>

<style lang="scss" scoped>
  @import "~sb_sass/variables";
  @import "~sb_sass/mixins";

  .social-btn {
    width: 100%;
    color: #0f1626;
    display: flex;
    align-items: center;
    justify-content: center;
    grid-column-gap: 0.25rem;
    font-weight: 600;
    border-radius: .5rem;
    padding: 13px 28px;
    font-size: 1rem;
    border: 1px solid #cbd5e1;
    background: $white;
    cursor: pointer;
    transition: box-shadow 0.2s;
    box-shadow: inset 0 1px 8px #ffffff26, 0 2px 6px -2px #0000001a;
    &:hover {
      background-color: #f8fafc;
      color: $blue-90;
    }
    .social-icon {
      width: 24px;
      height: 24px;
      margin-right: 0px;
    }
  }
</style>
